import React from "react";
import { ListItemText as MUIListItemText, Typography } from "@mui/material";

const ListItemText = ({ item }) => {
  const title = (
    <Typography xs={12} variant="body2" component="span">
      <b>Code: </b> {item.code}
    </Typography>
  );

  return <MUIListItemText primary={title} />;
};

export default ListItemText;
